export const USD_TO_INR_RATE = 1;

const RUPEE_SYMBOL = '\u20B9';

const parseCurrencyAmount = (amount: number | string): number => {
  const numericAmount =
    typeof amount === 'number'
      ? amount
      : parseFloat(String(amount || '0').replace(/[\u20B9$,]/g, ''));

  return Number.isNaN(numericAmount) ? 0 : numericAmount;
};

const isIndianCountry = (country?: string | null): boolean => {
  if (!country) return false;

  const normalizedCountry = country.trim().toLowerCase();
  return normalizedCountry === 'india' || normalizedCountry === 'in';
};

export const getCurrencySymbol = (country?: string | null): string => {
  return isIndianCountry(country) ? RUPEE_SYMBOL : '$';
};

export const convertDbToDisplay = (
  amount: number | string,
  _country?: string | null
): number => {
  return parseCurrencyAmount(amount);
};

export const convertDisplayToDb = (
  amount: number | string,
  _country?: string | null
): number => {
  return parseCurrencyAmount(amount);
};

export const formatCurrency = (
  amount: number | string,
  country?: string | null,
  options?: Intl.NumberFormatOptions
): string => {
  const numericAmount = parseCurrencyAmount(amount);
  const isIndia = isIndianCountry(country);
  const symbol = getCurrencySymbol(country);

  const defaultOptions: Intl.NumberFormatOptions = {
    minimumFractionDigits: isIndia ? 0 : 2,
    maximumFractionDigits: isIndia ? 0 : 2,
    ...options,
  };

  const formattedValue = numericAmount.toLocaleString(
    isIndia ? 'en-IN' : 'en-US',
    defaultOptions
  );

  return `${symbol}${formattedValue}`;
};
